import { Route, Switch } from 'react-router-dom';
import { Subscribe } from 'unstated';

import ColumnSelectorDialog from '~/components/DynamicTable/ColumnSelectorDialog';
import Footer from '~/components/Footer';
import Page from '~/components/Page';
import SearchTextField from '~/components/SearchTextField';
import FormsContainer from '~/containers/Forms';
import {
  exportResponses,
  getAllResponseColumns,
  getResponseColumns,
  updateResponseColumns,
} from '~/lib/client';

import EditForm from './form/EditForm';
import Embed from './form/Embed';
import FormSaveButton from './form/FormSaveButton';
import Responses from './form/Responses';
import ListResponsesSettingsMenu from './form/responses/ListResponsesSettingsMenu';
import Settings from './form/Settings';
import styles from './ShowForm.style';

class ShowForm extends React.Component {
  state = {
    settingsPopup: false,
    chooseColumnDialog: false,
    columns: [],
    allColumns: [],
  };

  UNSAFE_componentWillMount = () => {
    this.fetchColumns();
  };

  fetchColumns = () => {
    const { form } = this.props;

    Promise.all([
      getAllResponseColumns(form.id),
      getResponseColumns(form.id),
    ]).then(([allColumns, columns]) => {
      this.setState({ allColumns, columns });
    });
  };

  onClickChooseColumns = () => {
    this.setState({
      chooseColumnDialog: true,
      settingsPopup: false,
    });
  };

  exportResponses = () => {
    const { form } = this.props;
    exportResponses({ form_id: form.id });
  };

  closeSettingsPopup = () => {
    this.setState({ settingsPopup: false });
  };

  onCloseChooseColumns = (columns) => {
    const { form } = this.props;

    this.setState({
      chooseColumnDialog: false,
      settingsPopup: false,
    });

    if (columns) {
      updateResponseColumns({
        columns: columns,
        form_id: form.id,
      }).then((columns) => this.setState({ columns: columns }));
    }
  };

  render() {
    const { form, classes, onChange, onSave, onRefreshForm } = this.props;

    const {
      columns,
      allColumns,
      columnMappings,
      chooseColumnDialog,
    } = this.state;

    return (
      <Subscribe to={[FormsContainer]}>
        {(container) => (
          <div className={classes.root}>
            <Switch>
              <Route path="/forms/:formId/responses">
                <div className={classes.filter}>
                  <p className={classes.filterCount}>All responses</p>

                  <SearchTextField
                    classes={{ root: classes.filterSearch }}
                    debounceInterval={300}
                    value={container.state.searchQuery || ''}
                    placeholder="Search by name or email..."
                    onSearch={(event) => {
                      container.setState({
                        searchQuery: event.target.value,
                      });
                    }}
                  />
                  <ListResponsesSettingsMenu
                    onClickChooseColumns={this.onClickChooseColumns}
                    exportResponses={this.exportResponses}
                  />
                  <ColumnSelectorDialog
                    columns={columns}
                    allColumns={allColumns}
                    open={chooseColumnDialog}
                    onClose={this.onCloseChooseColumns}
                  />
                </div>
              </Route>
            </Switch>

            <Page className={classes.formPage}>
              <div className={classes.tabContent}>
                <Switch>
                  <Route
                    path="/forms/:formId"
                    exact
                    render={() => (
                      <EditForm
                        form={form}
                        onChange={onChange}
                        onRefreshForm={onRefreshForm}
                        onSave={onSave}
                      />
                    )}
                  />

                  <Route
                    path="/forms/:formId/preview"
                    render={() => (
                      <Embed form={form} onChange={this.props.onChange} />
                    )}
                  />

                  <Route
                    path="/forms/:formId/responses"
                    render={() => (
                      <Responses
                        form={form}
                        columns={columns}
                        columnMappings={columnMappings}
                        deleteResponse={container.deleteResponse}
                      />
                    )}
                  />

                  <Route
                    path="/forms/:formId/connectors"
                    render={() => (
                      <Settings form={form} onChange={this.props.onChange} />
                    )}
                  />
                </Switch>
              </div>
            </Page>

            <Route
              exact
              path={`/forms/${form.id}(|/preview)`}
              render={() =>
                form.isDirty && (
                  <Footer
                    right={
                      <div className={classes.saveAction}>
                        <FormSaveButton
                          disabled
                          onSave={onSave}
                          isDirty={form.isDirty}
                        />
                      </div>
                    }
                  />
                )
              }
            />
          </div>
        )}
      </Subscribe>
    );
  }
}

ShowForm.propTypes = {
  classes: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onRefreshForm: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

export default withStyles(styles)(ShowForm);
